<template>
  <div :class="[isCheckbox ? 'col-lg-12' : 'col-lg-9']">
    <div class="form-group" v-if="['list','radio','switch','formula','variable'].indexOf(featureType) > -1">
      <label for="feature-normal-product">ویژگی</label>
      <select v-model="featureProduct.feature_attribute_id" class="form-control custom-select">
        <option v-for="item in featureAttributes" :value="item.id">{{ item.value }}</option>
      </select>
    </div>
    <div class="form-group" v-if=" featureType == 'text'  ">
      <label for="feature-normal-product">توضیحات</label>
      <textarea v-model="featureProduct.feature_value" class="form-control "/>
    </div>
    <div class="form-group" v-if=" featureType == 'link'  ">
      <label for="feature-normal-product">لینک</label>
      <input v-model="link.name" class="form-control my-1"/>
      <input v-model="link.value" class="form-control my-1"/>

    </div>
    <div class="form-group" v-if="['list-with-number-value','list-with-text-value'].indexOf(featureType) > -1 ">
      <label for="feature-normal-product">ویژگی</label>
      <select v-model="featureProduct.feature_attribute_id" class="form-control custom-select">
        <option v-for="item in featureAttributes" :value="item.id">{{ item.value }}</option>
      </select>
      <input :type="featureType == 'list-with-number-value' ? 'number':'text' " v-model="featureProduct.feature_value"
             class="form-control my-1"/>
    </div>
    <div class="form-group" v-if="featureType == 'checkbox'">
      <checkbox-item-config :product="product" :product-feature="featureProduct"/>
    </div>
    <feature-item-extra v-if="!isCheckbox" :product="product" :product-feature="featureProduct"/>
  </div>
</template>

<script>
import CheckboxItemConfig from "./CheckboxItemConfig.vue";
import FeatureItemExtra from "./FeatureItemExtra.vue";

export default {
  name: "NormalItemConfig",
  components: {FeatureItemExtra, CheckboxItemConfig},
  data() {
    return {
      link: {
        name: '',
        value: ''
      }
    }
  },
  props: {
    featureProduct: {},
    product: {},
  },
  computed: {
    featureType() {
      return this.isCheckbox ? 'checkbox' : this.featureProduct.feature.type
    },
    featureAttributes() {
      return this.featureProduct.feature.feature_attributes
    },
    isCheckbox() {
      return Array.isArray(this.featureProduct)
    }
  },
  methods: {
    setLinkValue() {
      if (this.featureType == 'link') {
        let featureValue = this.featureProduct.feature_value.split('|')
        this.link.name = featureValue[0]
        this.link.value = featureValue[1]
      }
    }
  },
  mounted() {
    this.setLinkValue()
  },
  watch: {
    link: {
      handler(oldValue, newValue) {
        this.featureProduct.feature_value = `${this.link.name}|${this.link.value}`
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>